import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectDeletionService, ProjectDeletionBatch } from '../../../services/project-deletion.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-project-deletion-progress',
  templateUrl: './project-deletion-progress.component.html',
  styleUrls: ['./project-deletion-progress.component.scss']
})
export class ProjectDeletionProgressComponent implements OnInit, OnDestroy {
  batchId = '';
  batch: ProjectDeletionBatch | null = null;
  loading = false;
  cancelling = false;
  private poll?: ReturnType<typeof setInterval>;
  constructor(private route: ActivatedRoute, private router: Router, private svc: ProjectDeletionService, private toast: ToastService) {}
  ngOnInit(): void {
    this.batchId = this.route.snapshot.paramMap.get('batchId') ?? '';
    if (!this.batchId) { this.router.navigate(['/dashboard']); return; }
    this.refresh(); this.startPolling();
  }
  ngOnDestroy(): void { this.stopPolling(); }
  async refresh(): Promise<void> {
    this.loading = true;
    try {
      this.batch = await firstValueFrom(this.svc.getBatch(this.batchId));
      if (this.batch.status !== 'Running' && this.batch.status !== 'Pending') this.stopPolling();
    } catch { this.toast.showToast('error', 'Error cargando el progreso.'); }
    finally { this.loading = false; }
  }
  private startPolling(): void { if (!this.poll) this.poll = setInterval(() => void this.refresh(), 2000); }
  private stopPolling(): void { if (this.poll) { clearInterval(this.poll); this.poll = undefined; } }
  get isRunning(): boolean { return this.batch?.status === 'Running' || this.batch?.status === 'Pending'; }
  get progress(): number {
    if (!this.batch || this.batch.totalSteps === 0) return 0;
    const done = this.batch.successCount + this.batch.failedCount + this.batch.skippedCount;
    return Math.round((done / this.batch.totalSteps) * 100);
  }
  async cancel(): Promise<void> {
    if (!this.isRunning || this.cancelling) return;
    if (!confirm('¿Cancelar el borrado? Las fases pendientes quedarán como Omitidas. Lo ya borrado NO se restaura.')) return;
    this.cancelling = true;
    try { await firstValueFrom(this.svc.cancel(this.batchId)); this.toast.showToast('info', 'Cancelación solicitada.'); this.refresh(); }
    catch { this.toast.showToast('error', 'Error cancelando.'); }
    finally { this.cancelling = false; }
  }
  statusLabel(s: string): string {
    const m: Record<string,string> = { Pending:'Pendiente', Running:'En curso', Completed:'Completado', Failed:'Falló', Cancelled:'Cancelado', Skipped:'Omitido', Blocked:'Bloqueado' };
    return m[s] ?? s;
  }
  trackById = (_: number, i: { id: number }) => i.id;
}
